import { Injectable } from "@angular/core";
import { Socket } from "ngx-socket-io";

@Injectable({
    providedIn: 'root'
  })
  export class SocketService {
  
    constructor(private socket: Socket) {}
  
    connect(userId: string): void {
        console.debug("Hello Socket ")
      this.socket.ioSocket.io.opts.query = { userId };
      this.socket.connect();
      
      this.socket.on('connect', () => {
        console.debug('Connected to server');
      });
  
      this.socket.on('message', (data: any) => {
        console.debug("socket msg: ", data);
      });
  
      this.socket.on('notification', (data: any) => {
        alert(data.message);
      });
  
      this.socket.on('disconnect', () => {
        console.debug('Disconnected from server');
      });
    }
  
    disconnect(): void {
      this.socket.disconnect();
    }
  }